import Experience from "./experience";
import * as ZapparThree from "@zappar/zappar-threejs";
import "./style.css";
import { initPenSelection } from "./dom/pages/PenSelection";
import { initPrompt } from "./dom/pages/Prompt";
import { initDraw } from "./dom/pages/Draw";
import { hideSplash, revealPermissions } from "./dom";
import { getUrlParams } from "./utils/urlParams";
import { checkWakelockSupported } from "./utils";
import { Params } from "./utils/types";
import { initDownload } from "./dom/pages/Download";
import { initTranslations } from "./translations";
import { sendTrackingEvent } from "./utils/events";
import { initTutorial } from "./dom/pages/Tutorial";

let splash_button = <HTMLElement>document.querySelector('.splash_button');
let permissions_button = <HTMLElement>document.querySelector('.permissions_button');

const experienceContainer = document.querySelector<HTMLDivElement>(".experience")!;

let urlParams: Params;
const experience = new Experience({ targetElement: experienceContainer });

async function init() {
    await getUrlParams().then((params: Params) => {
        urlParams = params;
        console.log('url Params', urlParams)
        experience.init(urlParams);
    })
    initTranslations();
    checkWakelockSupported()
};
init()

splash_button.addEventListener("touchend", () => {
    sendTrackingEvent('User tapped Launch');
    console.log('splash button pressed')
    hideSplash()
    revealPermissions()
});

permissions_button.addEventListener("touchend", () => {
    console.log('permissions button pressed')
    sendTrackingEvent('User tapped Continue');
    requstPermissions()
});


function requstPermissions() {
    ZapparThree.permissionRequest().then(granted => {
        if (granted) {
            experience.start();
            initPrompt(urlParams);
            initPenSelection(urlParams);
            initDraw();
            initDownload();
            initTutorial();
            sendTrackingEvent('User tapped to allow camera access permissions');
        } else {
            ZapparThree.permissionDeniedUI();
            sendTrackingEvent('User tapped to cancel camera access permissions');
        }
    });
}

export function triggerDrawControl(trigger: string) {
    experience.triggerDrawControl(trigger)
}

export function updatePhoneDirection(phoneDown: boolean) {
    experience.updatePhoneDirection(phoneDown);
}